export const redoIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M15.33 8.83C13.8 7.5 11.8 6.67 9.58 6.67c-3.87 0-7.15 2.52-8.3 6l1.97.65c.88-2.65 3.38-4.58 6.33-4.58 1.63 0 3.1.6 4.27 1.57l-3.02 3h7.5v-7.5l-3 3z"/></svg>`,
  name: 'redo',
};
